import { colors } from '../../tokens';
export default {
  wrapper: {
    width: '100%',
    minHeight: '64px',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    position: 'relative'
  },
  container: {
    position: 'relative',
    width: '100%',
    minHeight: '64px',
    borderRadius: '4px',
    borderStyle: 'solid',
    borderWidth: '1px',
    boxSizing: 'border-box',
    transition: 'padding-left 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, border-color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, border-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms'
  },
  labelText: {
    fontSize: '16px',
    color: colors.grey[300],
    zIndex: 1,
    transform: 'translate(16px, 24px) scale(1)',
    pointerEvents: 'none',
    transition: 'color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms',
    top: 0,
    left: 0,
    position: 'absolute',
    transformOrigin: 'top left',
    padding: 0,
    lineHeight: 1,
    transformActive: 'translate(16px, 12px) scale(0.75)'
  },
  helperText: {
    fontSize: '12px',
    padding: '6px 0 0 2px'
  },
  icon: {
    color: colors.brand.primary,
    position: 'absolute',
    top: 0,
    right: 0,
    width: '16px',
    height: '16px',
    transform: 'translate(-16px, 24px)',
    paddingInput: '28px 48px 12px 16px'
  },
  inputElement: {
    fontSize: '16px',
    color: colors.dark,
    width: '100%',
    border: 0,
    margin: 0,
    display: 'block',
    minWidth: 0,
    background: 'none',
    outline: 'none',
    boxSizing: 'border-box',
    '-webkit-tap-highlight-color': 'transparent',
    minHeight: '62px',
    lineHeight: 1.3,
    padding: '28px 16px 12px 16px',
    '&::placeholder': {
      transition: 'opacity 100ms cubic-bezier(0, 0, 0.2, 1) 0ms',
      opacity: 0,
      fontSize: '16px',
      color: colors.grey[300]
    },
    '&:focus::placeholder': {
      opacity: 1
    }
  },
  "default": {
    borderColor: colors.grey[300],
    borderColorActive: colors.brand.primary,
    labelTextActive: colors.brand.primary,
    helperText: colors.grey[500]
  },
  success: {
    borderColor: colors.success,
    borderColorActive: colors.success,
    labelTextActive: colors.success,
    helperText: colors.grey[500]
  },
  error: {
    borderColor: colors.error,
    borderColorActive: colors.error,
    labelTextActive: colors.error,
    helperText: colors.error
  },
  password: {
    icon: {
      color: colors.grey[300],
      cursor: 'pointer'
    }
  },
  date: {
    icon: {
      color: colors.brand.primary,
      cursor: 'pointer'
    }
  }
};